import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disaster-protection',
  templateUrl: './disaster-protection.component.html',
  styleUrls: ['./disaster-protection.component.css']
})
export class DisasterProtectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
